// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"ae0fc2bf","340":"330986bc","514":"a997bb6f","569":"65fa9f30","570":"15e5b24a","788":"60531bdd"}[chunkId] + ".chunk.js";
};